import {Component, Inject, OnInit} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {HeaderComponent} from './header/header.component';
import { DOCUMENT } from '@angular/common';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { effect, inject } from '@angular/core';
import { CookieConsentService } from './services/cookie-consent.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, HeaderComponent,CookieConsentComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
    private readonly consent = inject(CookieConsentService);

    constructor( @Inject(DOCUMENT) private document: Document) {
        effect(() => {
            if (this.consent.hasConsent('analytics')) {
                this.consent.loadGoogleAnalytics( environment.googleTagMeasurementId ); // your own function that injects the <script> tag
                //console.log("Loaded analytics" + environment.googleTagMeasurementId);
            }
            // if (this.consent.hasConsent('marketing')) {
            //     loadMarketingPixels();
            // }
        });
    }

    ngOnInit() {
        this.document.documentElement.lang = 'da';
    }
    title = 'SISU Foto';
}
